import React, { useEffect, useState, useRef } from "react";
import './OperadoresVetados.scss';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from 'primereact/dialog'; // Importamos Dialog de PrimeReact
import { ColorValidation, SubmitValidation, UpdateValue } from "../../../utilidades/Validaciones";
import { getClientes, getOperadores, getOperadoresVetados, getPermissions, vetarOperador, vetarOreactivarOp } from "./integracion";
import { formatearFechaGuion } from "../../../utilidades/formateos";
import { Tooltip } from "@mui/material";
import useGetDataUser from "../../../utilidades/customHooks/useGetDataUser";
import {IconField} from "primereact/iconfield";
import {InputIcon} from "primereact/inputicon";

const OperadoresVetados = () => {
    const dataUser = useGetDataUser()
    const [inputList, setInputList] = useState({
        nombre: { value: null, validationType: "empty" },
        cliente: { value: null, validationType: "empty" },
        fecha: { value: new Date(), validationType: "empty" },
        observaciones: { value: null, validationType: "optional" },
    });

    const [nombres, setNombres] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [dataTable, setDataTable] = useState([]);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [permision, setPermision] = useState(null);
    // Nuevo estado para controlar la visibilidad del diálogo/formulario
    const [displayFormDialog, setDisplayFormDialog] = useState(false);

    // Referencia para resetear el formulario (opcional)
    const initialInputListRef = useRef({
        nombre: { value: null, validationType: "empty" },
        cliente: { value: null, validationType: "empty" },
        fecha: { value: new Date(), validationType: "empty" },
        observaciones: { value: null, validationType: "optional" },
    });

    useEffect(() => {
        for (const element in inputList) {
            if (document.getElementById(element)) {
                // ColorValidation(element, inputList, "empty")
            }
        }
    }, [inputList]);
    console.log("permision", permision);

    useEffect(() => {
        if (dataUser) {
            getOperadoresVetados(setDataTable, dataUser?.user?.ID);
            getPermissions(setPermision, dataUser?.user?.ID)
            getClientes(setClientes);
            getOperadores(setNombres);
        }
    }, [dataUser]);

    const resetForm = () => {
        setInputList(initialInputListRef.current);
        // Aquí podrías añadir lógica para limpiar visualmente las validaciones si las tienes
    };

    const subirOperador = () => {
        if (SubmitValidation(inputList, setInputList)) {
            vetarOperador(setDataTable, inputList.nombre.value.code, inputList.cliente.value.code, formatearFechaGuion(inputList.fecha.value), inputList.observaciones.value, dataUser?.user?.ID);
            setDisplayFormDialog(false); // Cerrar el diálogo después de enviar
            resetForm(); // Limpiar el formulario
        }
    };
    const handleToggleOperadorStatus = async (rowData) => {
        console.log("Operador a modificar:", rowData);
        // Lógica para enviar la solicitud al backend
        const newStatus = rowData.ACTIVO === 1 ? 0 : 1; // Cambia el estado
        const confirmation = window.confirm(`¿Estás seguro de ${newStatus === 1 ? 'activar' : 'desactivar'} a ${rowData.NOMBRE}?`);

        if (confirmation) {
            try {
                vetarOreactivarOp(rowData.ACTIVO ? '0' : '1', rowData.FOLIO)
                setDataTable(prevDataTable =>
                    prevDataTable.map(op =>
                        op.FOLIO === rowData.FOLIO ? { ...op, ACTIVO: newStatus } : op
                    )
                );
            } catch (error) {
                console.error("Error al cambiar el estado del operador:", error);
                alert("Hubo un error al procesar la solicitud.");
            }
        }
    };


    const actionBodyTemplate = (rowData) => {
        const isActive = rowData.ACTIVO === 1;

        return (
            <div className="acciones-columna">
                {isActive ? (
                    <Tooltip title='Desactivar'>
                        <div>
                            <Button
                                icon="pi pi-times-circle" // Icono para desactivar
                                className="p-button-rounded p-button-danger p-button-sm"
                                onClick={() => handleToggleOperadorStatus(rowData)}
                                disabled={permision?.PERMISO == 0}
                            />
                        </div>
                    </Tooltip>
                ) : (
                    <Tooltip title='Activar'>
                        <div>
                            <Button
                                icon="pi pi-check-circle" // Icono para activar
                                className="p-button-rounded p-button-success p-button-sm"
                                onClick={() => handleToggleOperadorStatus(rowData)}
                                disabled={permision?.PERMISO == 0}
                            />
                        </div>
                    </Tooltip>
                )}
                {/* Puedes añadir más botones aquí si necesitas otras acciones como editar o ver detalles */}
                {/* <Button
                    icon="pi pi-pencil"
                    className="p-button-rounded p-button-info p-button-sm ml-2" // ml-2 es para margin-left
                    tooltip="Editar Operador"
                    onClick={() => console.log("Editar:", rowData)}
                /> */}
            </div>
        );
    };

    const renderHeader = () => {
        return (
            <div className="table-header-content">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar en la tabla" />
                </IconField>
                {/* Botón para abrir el formulario */}
                {
                    permision?.PERMISO > 0 && (
                        <Button
                            label="Vetar Nuevo Operador"
                            icon="pi pi-plus"
                            className="p-button-success new-vet-button"
                            onClick={() => setDisplayFormDialog(true)}
                        />
                    )
                }
            </div>
        );
    };

    const header = renderHeader();

    // Contenido del formulario para el diálogo
    const formContent = (
        <div className="form-grid">
            <div className="form-field">
                <label htmlFor="nombre">Nombre</label>
                <Dropdown
                    id="nombre"
                    value={inputList.nombre.value}
                    options={nombres}
                    onChange={(e) => UpdateValue(e, "nombre", inputList, setInputList)}
                    optionLabel="name"
                    placeholder="Selecciona un operador"
                    filter
                    showClear
                />
            </div>
            <div className="form-field">
                <label htmlFor="cliente">Cliente</label>
                <Dropdown
                    id="cliente"
                    value={inputList.cliente.value}
                    options={clientes}
                    onChange={(e) => UpdateValue(e, "cliente", inputList, setInputList)}
                    optionLabel="name"
                    placeholder="Selecciona un cliente"
                    filter
                    showClear
                />
            </div>
            <div className="form-field">
                <label htmlFor="fecha">Fecha</label>
                <Calendar
                    id="fecha"
                    value={inputList.fecha.value}
                    onChange={(e) => UpdateValue(e, "fecha", inputList, setInputList)}
                    dateFormat="dd/mm/yy"
                    showIcon
                />
            </div>
            <div className="form-field full-width-field">
                <label htmlFor="observaciones">Observaciones</label>
                <InputTextarea
                    id="observaciones"
                    value={inputList.observaciones.value}
                    onChange={(e) => UpdateValue(e, "observaciones", inputList, setInputList)}
                    rows={5}
                    cols={30}
                    autoResize
                />
            </div>
        </div>
    );

    // Footer del diálogo
    const formDialogFooter = (
        <div className="dialog-footer-buttons">
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={() => { setDisplayFormDialog(false); resetForm(); }} />
            <Button label="Vetar Operador" icon="pi pi-ban" className="p-button-danger" onClick={subirOperador} />
        </div>
    );

    return (
        <div className="operadores-vetados-page">
            <div className="content-container table-focus-layout"> {/* Nueva clase para el layout con foco en tabla */}
                <div className="table-section-container main-table-view"> {/* La tabla es el foco principal */}
                    <Card className="data-table-card">
                        <DataTable
                            value={dataTable}
                            header={header}
                            globalFilter={globalFilter}
                            paginator
                            rows={50}
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            scrollable
                            scrollHeight="calc(100vh - 260px)" // Usar 'flex' para que la tabla ocupe el espacio restante
                            emptyMessage="No se encontraron registros."

                        // className="p-datatable-sm" // <<< Asegúrate de que esta línea esté comentada o eliminada
                        >
                            <Column field="FOLIO" header="Folio" sortable></Column>
                            <Column field="ID_OPERADOR" header="Id Operador" sortable></Column>
                            <Column field="NOMBRE" header="Nombre" sortable></Column>
                            <Column field="CLIENTE" header="Cliente" sortable></Column>
                            <Column field="FECHA" header="Fecha" sortable></Column>
                            <Column field="OBSERVACIONES" header="Observaciones"></Column>
                            <Column field="ACCIONES" header="ACCIONES" body={actionBodyTemplate}></Column>
                        </DataTable>
                    </Card>
                </div>
            </div>

            {/* Diálogo para el formulario de Vetar Operador */}
            <Dialog
                header="Vetar Nuevo Operador"
                visible={displayFormDialog}
                style={{ width: '50vw' }} // Ancho del diálogo
                breakpoints={{ '960px': '75vw', '641px': '90vw' }} // Responsive
                modal
                footer={formDialogFooter}
                onHide={() => { setDisplayFormDialog(false); resetForm(); }}
            >
                {formContent}
            </Dialog>
        </div>
    );
};

export default OperadoresVetados;